module.exports = __webpack_public_path__ + "media/images/new-ui-images/edit-icon-7dc3d3f97d701614b166e6717de1668c.svg";